import '../style/home.css';

const Home = () => {
    return (
      <div className='home'>
        <div className='homeText'>
          <h3>keep it</h3>
          <h2>simple.</h2>
        </div>
      </div>
    );
  }
  
  export default Home;